import { useCallback, useEffect, useMemo } from 'react';

import { getRecordKeyFor } from '~/reducers/customerCommunicationReducer';

import fetchHeroPlannerCitySegments from '~/actions/customerCommunication/fetchHeroPlannerCitySegments';

import { useAppDispatch, useAppSelector } from '../store';

function useHeroPlannerCitySegments(
  countryGroupId: string,
  countryId: string,
  stateId: string,
  cityId: string,
  brand: string,
) {
  const [key, params] = useMemo(() => {
    const params: Parameters<typeof fetchHeroPlannerCitySegments> = [brand, countryGroupId, countryId, stateId, cityId];
    return [getRecordKeyFor(...params), params];
  }, [brand, countryGroupId, countryId, stateId, cityId]);
  const segmentsReq = useAppSelector(
    (state) => state.customerCommunication.countryGroupCountryStateCitySegmentsRecords[key],
  );
  const appDispatch = useAppDispatch();
  const fetchSegments = useCallback(() => {
    appDispatch(fetchHeroPlannerCitySegments(...params));
  }, [appDispatch, params]);
  useEffect(() => {
    fetchSegments();
  }, [fetchSegments]);

  return { segmentsReq, fetchSegments };
}

export default useHeroPlannerCitySegments;
